import './layout.scss'
import styles from './index.module.scss'
import moscaDigitalImg from '../images/mosca-digital.png'
import backArrowImg from '../images/backArrow.svg'

import React from 'react'
import produce from 'immer'
import { StaticQuery, graphql } from 'gatsby'
import CookieConsent from 'react-cookie-consent'

import SEO from '../components/Seo'
import Conditional from '../components/Conditional'
import HomeContent from '../components/HomeContent'
import Question from '../components/Question'
import FinishContent from '../components/FinishContent'
import SubmittedContent from '../components/SubmittedContent'
import { questions } from '../../config'
import { getPrice } from '../utils/utils'

class IndexPage extends React.Component {
  getInitialState = () => {
    return {
      currentQuestion: -1,
      answers: [],
      inTransition: false,
      submitted: false,
    }
  }

  state = this.getInitialState()

  reset = () => {
    this.withTransition(() => {
      this.setState(this.getInitialState(), () => this.updateHistory())
    })
  }

  withTransition = f => {
    if (!this.state.inTransition) {
      this.setState({ inTransition: true })
      setTimeout(() => {
        f()
        this.setState({ inTransition: false })
      }, 200)
    }
  }

  start = () => {
    this.withTransition(() => {
      this.setState(
        {
          currentQuestion: 0,
        },
        () => this.updateHistory()
      )
    })
  }

  onAnswerPick = answerIndex => {
    this.withTransition(() => {
      this.setState(
        produce(draft => {
          draft.currentQuestion++
          draft.answers.push(answerIndex)
        }),
        () => this.updateHistory()
      )
    })
  }

  back = () => {
    this.withTransition(() => {
      window.history.back()
    })
  }

  onSubmitSuccessful = () => {
    this.withTransition(() => {
      this.setState({ submitted: true }, () => this.updateHistory())
    })
  }

  onBackButtonEvent = e => {
    e.preventDefault()
    if (e.state) {
      this.withTransition(() => {
        this.setState(e.state)
        this.onStateChange()
      })
    }
  }

  componentDidMount () {
    window.onpopstate = this.onBackButtonEvent
    this.updateHistory(true)
  }

  updateHistory = replace => {
    const newState = {
      currentQuestion: this.state.currentQuestion,
      answers: this.state.answers,
      submitted: this.state.submitted,
    }
    this.onStateChange()
    if (replace) {
      window.history.replaceState(newState, '')
    } else {
      window.history.pushState(newState, '')
    }
  }

  onStateChange = () => {
    if (window.hj) {
      let url
      if (this.state.submitted) {
        url = '/thankyou'
      } else if (this.state.currentQuestion === -1) {
        url = '/'
      } else if (this.state.currentQuestion === questions.length) {
        url = '/estimate'
      } else {
        url = '/question/' + (this.state.currentQuestion + 1)
      }
      console.log(`url: ${ url }`)
      window.hj('stateChange', url)
    }
  }

  render () {
    const { currentQuestion, answers, submitted, inTransition } = this.state
    const firstScreen = !submitted && currentQuestion === -1
    const lastScreen = !submitted && currentQuestion >= questions.length
    const inQuestions = !submitted && !firstScreen && !lastScreen
    const currentPrice = getPrice(questions, answers)
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <div id="body-wrapper">
            <header className={firstScreen && inTransition ? 'inTransition' : ''}>
              {inQuestions && (
                <>
                  <div className={styles.headerRow}>
                    <span className={styles.back} onClick={this.back}>
                      <img className={styles.backArrow} src={backArrowImg} /> <span>Voltar</span>
                    </span>
                    <h4 className={styles.headerTitle}>{data.site.siteMetadata.title}</h4>
                    <span className={styles.headerPrice}>{currentPrice}€</span>
                  </div>
                  <div className={styles.headerRow}>
                    <span className={styles.counter}>{`${ currentQuestion + 1 }/${
                      questions.length
                    }`}</span>
                  </div>
                </>
              )}
              {(lastScreen || submitted) && (
                <div className={styles.headerRow}>
                  <span className={styles.back} onClick={this.reset}>
                    <img className={styles.backArrow} src={backArrowImg} /> Recomeçar
                  </span>
                </div>
              )}
            </header>

            <div id="content" className={inTransition ? 'inTransition' : ''}>
              <SEO />

              <Conditional showIf={firstScreen}>
                <HomeContent onStartPress={this.start} />
              </Conditional>

              {questions.map((question, i) => (
                <Conditional key={question.title} showIf={currentQuestion === i}>
                  <Question question={question} onAnswerPick={this.onAnswerPick} />
                </Conditional>
              ))}

              <Conditional showIf={lastScreen}>
                <FinishContent
                  price={currentPrice}
                  answers={answers}
                  onResetPress={this.reset}
                  onSubmitSuccessful={this.onSubmitSuccessful}
                />
              </Conditional>

              <Conditional showIf={submitted}>
                <SubmittedContent onResetPress={this.reset} />
              </Conditional>
            </div>
            <footer>
              <span className="crossover">
                Veja antes <a href="https://quantocustaumaapp.moscadigital.pt/">quanto custa uma app</a>
              </span>
              <span className="poweredBy">
                <span>© {new Date().getFullYear()}, Powered by</span>
                <a href="https://moscadigital.pt">
                  <img src={moscaDigitalImg} />
                </a>
              </span>
            </footer>
            <CookieConsent buttonText="OK">
              Somos obrigados a informar que este site tem uma cookie, mas não se preocupe que pode
              sempre acompanhar com um copinho de leite
            </CookieConsent>
          </div>
        )}
      />
    )
  }
}

export default IndexPage
